import React, { useState } from 'react';
import { Stepper, Step, StepLabel, Container, useMediaQuery, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';
import BasicInfo from './Steps/BasicInfo';
import { useStripe } from 'components/Stripe/StripeHookProvider';

import Membership from './Steps/Membership';
import StepButtonsDesktop from './StepButtonsDesktop';
import StepButtonsMobile from './StepButtonsMobile';
import { useFirebase } from 'components/Firebase/context';
import TextError from 'components/TextError';
import { withRouter } from 'react-router-dom';
import { ROUTE_HOME,ADMIN } from 'routes/routes';
import Loader from '../../components/Loader';
import { messages } from '../../../src/messages';

const useStyles = makeStyles(({ spacing, status, theme }) => ({
  root: {
    paddingRight: 0,

    paddingLeft: 0
  },
  stepView: {
    marginLeft: 8,
    marginRight: 8,
    marginBottom: 8
  },

  title: {
    paddingTop: 16,
    paddingBottom: 8
  },
  mobileStepper: {
    position: 'fixed',
    width: '100%',
    bottom: 0
  },
  successMessage: {
    margin: spacing(1),
    color: status.success,
    fontWeight: 300,
    maxWidth: '100%',
    display: 'inline-block',
    marginTop: '8em'
  }
}));

const SignUpStepper = ({ history }) => {
  const [activeStep, setActiveStep] = useState(1);
  //const lastStep = 2;

  const [membership, setMembership] = useState({
    membershipType: 'free',
    name: 'Free',
    address_zip: '',
    planId: 'prod_Gc4Wfr4euESbpE',
  });

  const [creds, setCreds] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    passwordConfirm: '',
    step: 1,
    isAdmin: false,
  });

  const classes = useStyles({});
  const theme = useTheme();
  const stripe = useStripe();
  const firebase = useFirebase();
  const [error, setError] = useState(null);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [loader, setLoader] = useState(false);
  const [successMessage, setsuccessMessage] = useState('');
  const [plan, setPlan] = useState(false);
  //const [customerID, setCustomerID] = useState();
  const onBasicInfoChanged = (name, value) => {
    setCreds({ ...creds, [name]: value });
  };
  const onMembershipChanged = (name, value, planId, planName) => {
    console.log('Plan Id', planId);
    setPlan(value == 'free' ? true : false);

    if (planId) {
      setMembership({ ...membership, [name]: value, planId: planId, name: planName });
    } else {
      setMembership({ ...membership, [name]: value });
    }

  };

  const isCredsComplete = () => {
    const { firstName, lastName, email, password, passwordConfirm } = creds;
    return firstName.length > 0 && lastName.length > 0 && email.length > 0 && password.length > 0 && passwordConfirm.length > 0 && password === passwordConfirm;
  };

  const getNextEnabled = () => {
    switch (activeStep) {
      case 1:
        return isCredsComplete();
      default:
        return 0;
    }
  };

  const validateEmail = (email) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const checkIfMailExist = (email) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");


  };


  const onNext = () => {

    const { firstName, lastName, email, password, passwordConfirm, step } = creds;
    if (step == 1) {
      // let's validate data here
      if (firstName == "") {
        return setError('Please enter first name');
      } else if (lastName === "") {
        return setError('Please enter last name');
      } else if (email === "" || !validateEmail(email)) {
        return setError('Please enter valid email');
      } else if (password === "" || password.length < 8) {
        return setError('Please enter a valid password, minimum 8 characraters');
      } else if (passwordConfirm === "" || password != passwordConfirm) {
        return setError('Password doesn\'t match');
      } else {
        setError('');
        setCreds({ ...creds, step: 2 });
      }
    } else {
      submit();
    }
  };

  async function submit() {
    try {
      setLoader(true);
      console.log('submit', membership, 'creds', creds);

      const email = creds.email.toString().trim();
      const customerName = creds.firstName.toString().trim() + ' ' + creds.lastName.toString().trim();
      const { token, error } = membership.membershipType != 'free' ? await stripe.createToken({ name: membership.name }) : '';

      if (error) {
        setLoader(false);
        return setError("Error : " + error.message);
      }

      // Check if email exists in firebase
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const url = process.env.FIREBASE_FUNCTIONS_URL || 'https://us-central1-body-f1rst-dev.cloudfunctions.net';
      const params = {
        method: 'GET',
        headers: myHeaders
      };

      fetch(url + '/getUserByMail?email=' + email, params)
        .then(response => response.json())
        .then(result => {
          if (result.status == 'error') {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("Authorization", "Bearer sk_test_MYEbvmTwBrdJpr9f3J46KbpV00gO6wNMYW");
            var urlencoded = new URLSearchParams();
            urlencoded.append("email", email);
            urlencoded.append("name", customerName);
            var requestOptions = {
              method: 'POST',
              headers: myHeaders,
              body: urlencoded
            };
            fetch("https://api.stripe.com/v1/customers", requestOptions)
              .then(response => response.json())
              .then(async (data) => {
                if (data.id) {
                  if (membership.membershipType != 'free') {
                    Addsources(data.id, token.id, membership.planId, creds);
                  } else {
                    createCustomer(creds, membership, membership.planId, data.id, token);
                  }
                }
              })
              .catch(error => {
                console.log('error', error)
                setLoader(false);
                setError(error.message);
                return;
              });
          } else {
            setLoader(false);
            setError('Email already used. Please try with different email.');
            return;
          }
        }).catch(err => {
          setLoader(false);
          setError('Stripe Error ' + err.message);
          return;
        });



    } catch (e) {
      setLoader(false);
      if (e.message) {
        console.log('Try catch error', e.message)
        setLoader(false);
        return setError(e.message);
      } else {
        setLoader(false);
        setError('An unexpected error occured!');
      }
    }
  }
  const Addsources = async (customerId, token, planId, creds) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer sk_test_MYEbvmTwBrdJpr9f3J46KbpV00gO6wNMYW");
    var urlencoded = new URLSearchParams();
    urlencoded.append("source", token);
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,

    };
    fetch("https://api.stripe.com/v1/customers/" + customerId + "/sources", requestOptions)
      .then(response => response.json())
      .then(async (result) => {
        console.log('sources success ===> ', result)
        var subscriptionBody = new URLSearchParams();
        subscriptionBody.append("customer", customerId);
        subscriptionBody.append("items[0][plan]", planId);
        var subsReqOptions = {
          method: 'POST',
          headers: myHeaders,
          body: subscriptionBody,
        };
        fetch("https://api.stripe.com/v1/subscriptions", subsReqOptions)
          .then(response => response.json())
          .then(async (result1) => {
            console.log('subscription success', result1);
            createCustomer(creds, membership, planId, customerId, token);
          })
          .catch(error => {
            setLoader(false);
            console.log('subscription error', error.message);

          });
      })
      .catch(error => {
        console.log('sources error', error.message);

      });
    //subscription 

  }

  const createCustomer = async (creds, membership, planId, customerId, token) => {
    const { user } = await firebase.doUserCreate(creds.email, creds.password, creds.isAdmin);
    const roles = {};
    if (creds.isAdmin) {
      roles[ADMIN] = ADMIN;
    };
    if (user.uid) {
      await firebase.firestore
        .collection('users')
        .doc(user.uid)
        .set({ membershipType: membership.membershipType, firstName: creds.firstName, lastName: creds.lastName, id: user.uid,roles: roles });
      if (token && token !== undefined) {
        await firebase.firestore
          .collection('stripe_customers')
          .doc(user.uid)
          .collection('tokens')
          .add({ token: token, planId: planId, customerId: customerId, membershipType: membership.membershipType, userId: user.uid });
      }
      setsuccessMessage(messages.successMessage);
      setTimeout(
        function () {
          history.push(ROUTE_HOME);
        }
          .bind(this),
        5000
      );
    }
  }




  const advanceText = loader ? <Loader /> : (creds.step === 2 ? 'Create Account' : 'next');

  const nextEnabled = getNextEnabled();
  const prevStep = () => {
    const { step } = creds;
    if (step == 2) {
      setCreds({ ...creds, step: 1 });
    }
  }
  return (
    <Container
      className={classes.root}
      maxWidth="xs"
      onKeyPress={e => e.charCode === 13 && nextEnabled && setCreds({ ...creds, step: 2 })}
    >
      {successMessage ?
        <Typography variant="h6" className={classes.successMessage} align="center" gutterBottom>
          {successMessage}
        </Typography>
        :
        <div>
          <Stepper activeStep={creds.step}>
            <Step>
              <StepLabel>Basic Info</StepLabel>
            </Step>
            <Step>
              <StepLabel>Membership</StepLabel>
            </Step>
          </Stepper>

          <Typography variant="h5" align="center" className={classes.title}>
            Sign Up
        </Typography>

          <div className={classes.stepView}>
            {creds.step === 1 && <BasicInfo {...creds} onChanged={onBasicInfoChanged} />}
            {creds.step === 2 && <Membership {...creds} onChanged={onBasicInfoChanged} {...membership} onMembershipChanged={onMembershipChanged} />}
          </div>
          {error && <TextError>{error}</TextError>}
          {!isMobile && (
            <StepButtonsDesktop
              onBack={prevStep}
              onNext={onNext}
              activeStep={creds.step == 1 ? 1 : 2}
              advanceText={advanceText}
            />
          )}

          {isMobile && (
            <StepButtonsMobile
              activeStep={activeStep}
              setActiveStep={setActiveStep}
              nextEnabled={nextEnabled}
              advanceText={advanceText}
            />
          )}
        </div>
      }
    </Container>
  );
};

export default withRouter(SignUpStepper);
